import { fromJS } from 'immutable';

import * as types from '../constants';

const defaultState = fromJS({
  top5Currencies: [],
  totalAutoCurrency: 0,
  totalCurrencyClick: 0,
  totalTranslations: 0,
  currencyCountChange: [],
  dateUpdate: [],
  translateCountChange: []
});

const overviewReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_COUNT_TOTAL:
      return state
        .set('totalAutoCurrency', action.data.total_auto_currency)
        .set('totalTranslations', action.data.total_translations)
        .set('totalCurrencyClick', action.data.total_currency_click)
        .set('top5Currencies', action.data.top_5_currencies);

    case types.SET_DATE_TIME:
      return state
        .set('currencyCountChange', fromJS(action.data.currencies_count_change || []))
        .set('dateUpdate', fromJS(action.data.date_update || []))
        .set('translateCountChange', action.data.languages_count_change);

    default:
      return state;
  }
};

export default overviewReducer;
